export const decisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionActions =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/insights/personalization_explainer/:dimension/actions" as const;
